import { Region } from './region';
import { Location } from './location';

export interface IUserInfo {
    id: number;
    email: string;
    name: string;
    culture: string;
    tenant: string;
    locationIds: number[];
    locations: Location[];
    regionIds: number[];
    regions: Region[];
    permissions: string[];
    active: boolean;
    isTokenValid: boolean;
}

export class User implements IUserInfo {
    id: number;
    email: string;
    name: string;
    culture: string;
    tenant: string;
    locationIds: number[];
    locations: Location[];
    regionIds: number[];
    regions: Region[];
    permissions: string[];
    active: boolean = true;
    isTokenValid: boolean = true;

    constructor(userInfo: IUserInfo | Object) {
        Object.assign(this, userInfo);
        // move regions to regionsIds
        this.regionIds = <any>this.regions;
        this.locationIds = <any>this.locations;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/models/user.ts